/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'; 
import StatusConectorEdg from '../../../modules/custom/EdgeConnector/StatusConectorEdg';
import { useAppSelector } from '../../../../redux/hooks';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap'; // Importar Spinner para la carga

const ConnectorEdg: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // Estado de loading

  // Validación de permisos y redirección
  useEffect(() => {
    const delay = setTimeout(() => {
      if (ListaPermisosTenant.includes('CC.View')) {
        navigate('/cloudConnectivity');
      } else {
        setLoading(false); // Detener la carga si el usuario tiene los permisos correctos
      }
    }, 1000); // Simular un retraso de 1 segundo para la validación de permisos

    // Limpiar el timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  // Mostrar spinner mientras se validan los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    );
  }

  return (
    <>
      <div className='card mb-5 mb-xl-5'>
        <StatusConectorEdg />
      </div>
    </>
  );
};

export { ConnectorEdg };
